import { put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import Logger from "../../Logger/Logger";
import ConfirmActions from "../../Action/Actions/ConfirmActions";

export default function* closePopup() {
  try {
    yield put(ConfirmActions.closePopup());
  } catch (err) {
    Logger.logError(err);
  }
}

export function* watchClosePopup() {
  yield takeEvery(Constants.PAGE_CONFIRM_CLOSE_POPUP_START, closePopup);
}
